import React from "react"
import {Button} from "../button/button"

interface ModeToggleButtonProps {
  isEnabled: boolean
  onClick: () => void
}

export const ModeToggleButton: React.FC<ModeToggleButtonProps> = ({isEnabled, onClick, children}) => {
  return <>
    <Button onClick={onClick} buttonStyle={isEnabled ? "primary" : "secondary"} buttonSize="small">
      {children}
    </Button>
  </>
}